import { BaseResource } from "./BaseResource";
import { apiResourceUrl } from "@ploy-lib/core";
export const AccessLevels = {
    None: -1,
    NotSet: 0,
    Hide: 1,
    View: 2,
    Edit: 3,
    Full: 4
};
export class FeatureAccessLevelResource extends BaseResource {
    pk() {
        return this.id.toString();
    }
}
FeatureAccessLevelResource.urlRoot = apiResourceUrl("access-levels");
//# sourceMappingURL=FeatureAccessLevelResource.js.map